.BlockClickTooltip {
  display: inline-flex;
  cursor: pointer;

  &.tooltipped-multiline::after {
    width: 160px;
  }
}
